/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Grid from "@mui/material/Grid";
import Divider from "@mui/material/Divider";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";

// @mui icons

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

// Material Dashboard 2 React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import ProfileInfoCard from "examples/Cards/InfoCards/ProfileInfoCard";
import ProfilesList from "examples/Lists/ProfilesList";

// Overview page components
import Header from "layouts/profile/components/Header";
import PlatformSettings from "layouts/profile/components/PlatformSettings";

// Data
import profilesListData from "layouts/profile/data/profilesListData";

// Images
import webIcon from "assets/images/icons/omnio/web.png";
import xIcon from "assets/images/icons/omnio/x.png";
import linkedinIcon from "assets/images/icons/omnio/linkedin.png";

function Overview() {
  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox mb={2} />
      <Header>
        <MDBox mt={5} mb={3}>
          <Grid container spacing={1}>
            <Grid item xs={12} md={6} xl={4}>
              <PlatformSettings />
            </Grid>
            <Grid item xs={12} md={6} xl={4} sx={{ display: "flex" }}>
              <Divider orientation="vertical" sx={{ ml: -2, mr: 1 }} />
              <ProfileInfoCard
                title="profile information"
                description={
                  <>
                    Hello, I&apos;m Michael. Through innovation we will help you achieve new
                    possibilities. We are partners in this journey.
                    <br />
                    <br />
                    OmnioFarm - <em>Dream in Detail</em>
                  </>
                }
                info={{
                  fullName: "Michael Samson",
                  mobile: "+27 71 376 1860",
                  email: "msamson@omniofarm.com",
                  location: "Cape Town, South Africa",
                }}
                social={[
                  {
                    link: "https://www.omniofarm.com",
                    icon: webIcon,
                    color: "facebook",
                    alt: "OmnioFarm website",
                  },
                  {
                    link: "https://x.com/omniofarm",
                    icon: xIcon,
                    color: "twitter",
                    alt: "OmnioFarm on X",
                  },
                  {
                    link: "https://www.linkedin.com/company/omniofarm",
                    icon: linkedinIcon,
                    color: "instagram",
                    alt: "OmnioFarm on LinkedIn",
                  },
                ]}
                action={{ route: "", tooltip: "Edit Profile" }}
                shadow={false}
              />
              <Divider orientation="vertical" sx={{ mx: 0 }} />
            </Grid>
            <Grid item xs={12} xl={4}>
              <ProfilesList title="conversations" profiles={profilesListData} shadow={false} />
            </Grid>
          </Grid>
        </MDBox>
        <MDBox px={2} py={3}>
          <Card
            sx={{
              borderRadius: 3,
              border: (theme) => `1px solid ${theme.palette.grey[200]}`,
              boxShadow: "0 12px 30px -20px rgba(15, 23, 42, 0.45)",
              textAlign: "center",
              bgcolor: "background.paper",
            }}
          >
            <CardContent sx={{ py: 5 }}>
              <MDTypography variant="h5" fontWeight="medium">
                We&apos;ll be with you very soon
              </MDTypography>
              <MDTypography variant="body2" color="text">
                &ndash; OmnioFarm team
              </MDTypography>
            </CardContent>
          </Card>
        </MDBox>
      </Header>
      <Footer />
    </DashboardLayout>
  );
}

export default Overview;
